import type { RouteObject } from "react-router-dom";
import { PagesOemComplianceCenterUiDisplay } from "./Display";

/**
 * One splat route, no children. The page reads the rest of the path itself — the tab, then the
 * hosted element's own path grammar — so there is no `<Outlet />` for a child route to render
 * into. The splat also serves the bare path, which the page redirects to a tab.
 */
export const PagesOemComplianceCenterUiRoutes: RouteObject[] = [
  {
    path: "oemComplianceCenter/*",
    element: <PagesOemComplianceCenterUiDisplay />
  }
];
